export default ".rain-upload-table {\n    width: 100%;\n    box-shadow: 0 0 10px #aaa;\n}\n";